<template>
  <div v-bind="$attrs"
       v-on="$listeners"
       :disabled="disabled"
       :class="$style.container"
       :style="containerStyle">
    <div :style="childContainerStyle">
      <div v-for="(tag, index) in tags" :key="index">
        <BaseTag v-bind="tagStyle"
                 :disabled="disabled">
          {{ tag }}
          <template v-if="!disableRemoveButton">
            <span :style="{ cursor: 'pointer', userSelect: 'none' }"
                  @click="removeTag(index)">
              <slot name="remove-tag-symbol">
                &#10005;
              </slot>
            </span>
          </template>
        </BaseTag>
      </div>
    </div>
  </div>
</template>

<script>
  import BaseTag from '@base/base-tag'
  import { DefaultPseudoClassAttributeNames,
           DefaultPseudoClassVariableNames,
           getPseudoClassesObject,
           filterObjectByArray} from '@js/vue-style-utils'

  export default {
    name: 'BaseTags',
    inheritAttrs: false,
    components: {
      BaseTag,
    },
    props: {
      disabled: { type: Boolean, required: false, default: false },
      disableRemoveButton: { type: Boolean, required: false, default: false },
      enableHorizontalScroll: { type: Boolean, required: false, default: false },
      enableVerticalScroll: { type: Boolean, required: false, default: false },
      tags: { type: Array, required: true },
      tagStyle: { type: Object, required: false, default: () => {}},
    },
    data: function () {
      return {
        childContainerStyle: {
          height: '100%',
          alignItems: 'center',
          display: 'flex',
        },
        containerStyle: {
          boxSizing: 'border-box',
        },
        flexWrap: 'none',
        maxHeight: null,
        postfixes: ['', 'hover', 'active', 'disabled'],
        overflowX: 'none',
        overflowY: 'none',
      };
    },
    created: function () {
      this.flexWrap = this.enableVerticalScroll ? 'wrap' : this.flexWrap;
      this.maxHeight = this.$attrs.maxHeight ? this.$attrs.maxHeight : this.$attrs.height ? this.$attrs.height : null;
      this.overflowX = this.enableHorizontalScroll ? 'auto' : this.overflowX;
      this.overflowY = this.enableVerticalScroll ? 'auto' : this.overflowY;

      this.childContainerStyle = {
        ...this.childContainerStyle,
        flexWrap: this.flexWrap,
        maxHeight: this.maxHeight,
        overflowX: this.overflowX,
        overflowY: this.overflowY,
      };

      const classObject = getPseudoClassesObject(
        this.$attrs, DefaultPseudoClassAttributeNames,
        '--base-tags-container-', DefaultPseudoClassVariableNames, this.postfixes);
      const attrs = filterObjectByArray(
        this.$attrs, DefaultPseudoClassAttributeNames);

      this.containerStyle = {
        ...this.containerStyle,
        ...attrs,
        ...classObject,
      };
    },
    methods: {
      removeTag: function (tagIndex) {
        this.$emit('remove-tag', tagIndex);
      },
    },
  };
</script>

<style lang="stylus" module>
  .container
    background-color var(--base-tags-container-background-color)
    border var(--base-tags-container-border)
    border-radius var(--base-tags-container-border-radius)
    border-width var(--base-tags-container-border-width)
    box-shadow var(--base-tags-container-box-shadow)
    &:hover
      background-color var(--base-tags-container-background-color-hover)
      border var(--base-tags-container-border-hover)
      border-radius var(--base-tags-container-border-radius-hover)
      border-width var(--base-tags-container-border-width-hover)
      box-shadow var(--base-tags-container-box-shadow-hover)
    &:active
      background-color var(--base-tags-container-background-color-active)
      border var(--base-tags-container-border-active)
      border-radius var(--base-tags-container-border-radius-active)
      border-width var(--base-tags-container-border-width-active)
      box-shadow var(--base-tags-container-box-shadow-active)
    &[disabled]
      background-color var(--base-tags-container-background-color-disabled)
      border var(--base-tags-container-border-disabled)
      border-radius var(--base-tags-container-border-radius-disabled)
      border-width var(--base-tags-container-border-width-disabled)
      box-shadow var(--base-tags-container-box-shadow-disabled)
</style>
